import React from "react";
import { motion } from "framer-motion";
import WataruSVG from "../../Assets/SVGWataru.svg";
import ReiSVG from "../../Assets/SVGRei.svg";
import KanataSVG from "../../Assets/SVGKanata.svg";
import ShuSVG from "../../Assets/SVGShu.svg";
import NatsumeSVG from "../../Assets/SVGNatsume.svg";
import { AiOutlineStar } from "react-icons/ai";

const loadingContainer = {
  width: "30rem",
  height: "12rem",
  display: "flex",
  justifyContent: "space-around"
};

const loadingWataru = {
  display: "block",
  width: "5rem",
  height: "5rem",
 // backgroundColor: "black",
 backgroundImage: `url(${WataruSVG})`
 
};

const loadingRei = {
    display: "block",
    width: "5rem",
    height: "5rem",
   // backgroundColor: "black",
   backgroundImage: `url(${ReiSVG})`
   
  };

  const loadingKanata = {
    display: "block",
    width: "5rem",
    height: "5rem",
   // backgroundColor: "black",
   backgroundImage: `url(${KanataSVG})`
   
  };

  const loadingShu = {
    display: "block",
    width: "5rem",
    height: "5rem",
   // backgroundColor: "black",
   backgroundImage: `url(${ShuSVG})`
   
  };

  const loadingNatsume = {
    display: "block",
    width: "5rem",
    height: "5rem",
   // backgroundColor: "black",
   backgroundImage: `url(${NatsumeSVG})`
   
  };

const loadingContainerVariants = {
  start: {
    transition: {
      staggerChildren: 0.2
    }
  },
  end: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const loadingCircleVariants = {
  start: {
    y: "0%"
  },
  end: {
    y: "100%"
  }
};

const loadingCircleTransition = {
  duration: 1,
  repeatType: "reverse",
  repeat: Infinity,
  ease: "easeInOut"
};

export default function PreCustom() {
  return (
    <div style={{textAlign: "center", fontWeight: "bold", position: "relative", top: "25%", width: "100%"}}>
    <div
    style={{
      //paddingTop: "15rem",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <motion.div
      style={loadingContainer}
      variants={loadingContainerVariants}
      initial="start"
      animate="end"
    >
      <motion.span
        style={loadingWataru}
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        style={loadingRei}
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        style={loadingKanata}
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        style={loadingShu}
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
      <motion.span
        style={loadingNatsume}
        variants={loadingCircleVariants}
        transition={loadingCircleTransition}
      />
    </motion.div>
    </div>
    <div className= "preload-title">ECCENTRIC PARTY NIGHT!! <AiOutlineStar/></div>
    </div>
  );
}